import React, { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Cell, PieChart, Pie } from "recharts";
import { useI18n, STATUS_LABELS } from "../../i18n";
import { api } from "../../lib/api";
import { StatCard } from "../../components/app/widgets";

const RISK_COLORS = { low: "hsl(152 76% 32%)", moderate: "hsl(38 92% 45%)", high: "hsl(24 90% 50%)", critical: "hsl(354 78% 54%)" };

export default function ManagementDashboard() {
  const { t, lang, fmt } = useI18n();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/management").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return <div className="text-muted-foreground">{t("loading")}</div>;

  const riskData = Object.entries(d.cases_by_risk).map(([k, v]) => ({ name: k, value: v, fill: RISK_COLORS[k] }));
  const statusData = Object.entries(d.cases_by_status).map(([k, v]) => ({ name: STATUS_LABELS[k] ? STATUS_LABELS[k][lang] : k, value: v }));

  return (
    <div className="space-y-6 gc-fade-up" data-testid="management-dashboard">
      <h1 className="font-display text-2xl font-bold text-[hsl(217_63%_15%)]">{t("nav_management")}</h1>
      <div className="grid lg:grid-cols-4 sm:grid-cols-2 gap-4">
        <StatCard testid="m-mrr" label={t("mrr")} value={`${fmt(d.mrr)}`} sub={t("sar")} accent="hsl(158 64% 28%)" />
        <StatCard testid="m-arr" label={t("arr")} value={`${fmt(d.arr)}`} sub={t("sar")} accent="hsl(217 63% 15%)" />
        <StatCard testid="m-clients" label={t("active_clients")} value={d.active_clients} />
        <StatCard testid="m-cases" label={t("total_cases")} value={d.total_cases} accent="hsl(199 89% 48%)" />
        <StatCard testid="m-sla" label={t("sla_perf")} value={`${d.sla_performance}%`} accent="hsl(158 64% 28%)" />
        <StatCard testid="m-review" label={t("avg_review")} value={d.avg_review_hours} />
        <StatCard testid="m-rework" label={t("rework_rate")} value={`${d.quality_rework_rate}%`} accent="hsl(38 92% 45%)" />
        <StatCard testid="m-leads" label={t("leads")} value={d.leads} accent="hsl(262 60% 55%)" />
      </div>

      <div className="grid lg:grid-cols-2 gap-5">
        <div className="rounded-2xl border border-border bg-card p-6">
          <div className="font-semibold text-[hsl(217_63%_15%)] mb-4">{t("cases_by_risk")}</div>
          <ResponsiveContainer width="100%" height={220}>
            <PieChart>
              <Pie data={riskData} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={80} label>
                {riskData.map((e, i) => <Cell key={i} fill={e.fill} />)}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        </div>
        <div className="rounded-2xl border border-border bg-card p-6">
          <div className="font-semibold text-[hsl(217_63%_15%)] mb-4">{t("cases_by_status")}</div>
          <ResponsiveContainer width="100%" height={220}>
            <BarChart data={statusData}>
              <XAxis dataKey="name" tick={{ fontSize: 10 }} interval={0} angle={-20} textAnchor="end" height={50} />
              <YAxis allowDecimals={false} tick={{ fontSize: 11 }} />
              <Bar dataKey="value" fill="hsl(217 63% 25%)" radius={[6, 6, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
